import React, { useState } from 'react';
import ArrowDown from '../../images/icons/ArrowDown.jsx';
import { mainMenu } from '../../constants/data.js';

export default function Dropdown(props) {
  const [ isShow, setIsShow ] = useState(false);
  const [ selected, setSelected ] = useState(mainMenu[0]);

  function handleActiveProduct(i) {
    setSelected(mainMenu[i]);
    props.setActiveTabIndex(mainMenu[i].id);
  }

  return (
    <div
      className={`w-72 ${ isShow ? 'h-[50px] bg-gray-100' :'h-[50px] bg-white' } items-center z-50 cursor-pointer relative rounded-3xl pl-8 box-shadow ${props.className}`}
      onClick={() => setIsShow(!isShow)}
    >
      {
        <img src={`https://proj-assets.onedio.com/sunum/${selected.link}.svg`} alt={selected.name} className='h-8 max-w-[100px]' />
      }
      <ArrowDown width='24' height='24' className={`${ isShow && 'rotate-180' } transition duration-500 absolute right-6 top-4`} />
      { isShow &&
        <div className='flex absolute top-14 left-0 w-full flex-col rounded-3xl border border-gray-200 bg-white'>
          {
            mainMenu.map((product, i) => {
              return (
                <div
                  className='flex items-center border-b h-14 px-7 border-stone-200 p-3 hover:px-8 transition-all duration-500'
                  key={product.id}
                  onClick={() => handleActiveProduct(i)}
                >
                  <img src={`https://proj-assets.onedio.com/sunum/${product.link}.svg`} alt={product} />
                </div>
              )
            })
          }
        </div>
        }
    </div>
  )
}
